<template>
  <aside
    class="columns small-12 medium-4 large-3 small-order-2 medium-order-1 tw-overflow-y-hidden"
  >
    <nav class="sidebar-nav sticky">
      <div class="parent-link">{{ category.parent?.name || category.name }}</div>
      <ul class="expanded-list">
        <category-nav-item
          v-for="item in items"
          :key="item.slug"
          :item="item"
          :country="country"
          :breadcrumbs="breadcrumbs"
        />
      </ul>
    </nav>
  </aside>
</template>

<script>
/* Category Nav
 *
 * @parent:
 * @requests:
 * @events:
 * @props: Array items
 * @components: CategoryNavItem
 * @methods:
 */

import CategoryNavItem from '~/components/category/CategoryNavItem.vue';

export default {
  name: 'CategoryNav',
  components: {
    CategoryNavItem,
  },
  props: {
    country: {
      type: String,
      default: null,
    },
    category: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    breadcrumbs: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  jsonld() {
    // Optional: create structured data from breadcrumbs if available
    if (!this.breadcrumbs) {
      return null;
    }

    // Structured data
    const breadcrumbs = this.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.link,
        name: item.name,
      },
    }));
    if (breadcrumbs.length > 0) {
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs,
      };
    } else {
      return {};
    }
  },
};
</script>
